import Input from './Input';
import { TextFieldLabel as InputLabel } from './styles';

export default Input;
export {
  InputLabel,
};
